export default "__VITE_ASSET__cd3bd4fa__"